import React, { useEffect, useState } from "react";
import {
  Alert,
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { getReciversUser } from "../../services/backend/UserService";

import { pqrsdText } from "./pqrsdLabel";
// Direct hand-off to another operator. No approval — matches the user's
// decision in the plan. The receiver's task lands in their inbox immediately.
export default function ForwardPqrsdDialog({
  open, onClose, onConfirm, busy, currentAssigneeId,
}) {
  const user = useSelector((state) => state.user.value);
  const [users, setUsers] = useState([]);
  const [pick, setPick] = useState(null);
  const [note, setNote] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || users.length || !user?.token) return;
    (async () => {
      const res = await getReciversUser(user.token);
      const list = Array.isArray(res) ? res : res?.users || res?.result || [];
      setUsers(Array.isArray(list) ? list : []);
    })();
  }, [open, user?.token, users.length]);

  const submit = async () => {
    if (!pick?.userId) {
      setError("Selecciona un destinatario.");
      return;
    }
    if (pick.userId === currentAssigneeId) {
      setError("Esa persona ya es el operario actual.");
      return;
    }
    try {
      setError(null);
      await onConfirm({
        toUser: {
          userId: pick.userId,
          name: `${pick.name || ""} ${pick.lastName || ""}`.trim(),
          email: pick.email,
        },
        note: note.trim() || null,
      });
      setPick(null); setNote("");
    } catch (e) {
      setError(e?.message || pqrsdText("No fue posible reenviar la PQRSD."));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{pqrsdText("Reenviar PQRSD")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Selecciona al funcionario que continuará la gestión. La asignación se
          transfiere de inmediato.
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Autocomplete
          options={users}
          getOptionLabel={(o) => `${o.name || ""} ${o.lastName || ""} <${o.email || ""}>`.trim()}
          value={pick}
          onChange={(_, v) => setPick(v)}
          renderInput={(params) => <TextField {...params} label="Funcionario destino" autoFocus />}
          noOptionsText="Sin resultados"
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          multiline
          minRows={2}
          label="Nota (opcional)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancelar</Button>
        <Button onClick={submit} variant="contained" disabled={!pick || busy}>Reenviar</Button>
      </DialogActions>
    </Dialog>
  );
}
